module.exports = __webpack_public_path__ + "04557760f74fdf33c3c8aee24dfd308a.svg";